import { noneProfile } from "assets";
import ImageUrl from "components/app/image-url/ImageUrl";
import { Loader, Minus, Plus } from "lucide-react";

const AddApproverRequest = ({
  employeeInitRequest,
  isRemovingApprover,
  setIsRemovingApprover,
  setEmployeeInitRequest,
  setIsOpenDialogApporver,
  getShopEmployeeRequestCommittee,
}: any) => {
  return (
    <div>
      <h4 className="text-xl font-semibold text-blue-600">Approvers</h4>
      <div className={`grid md:grid-cols-3 ${window.innerWidth <= 1500 ? "lg:grid-cols-5" : "lg:grid-cols-5"}  gap-y-3 gap-x-2 mb-10 mt-2 `}>
        {employeeInitRequest?.approvers?.map((item: any, index: number) => {
          return (
            <>
              <div key={index} className={`relative z-1 w-full max-w-sm border rounded-lg h-[370px] `}>
                <div className=" w-full relative overflow-hidden  ">
                  <ImageUrl className="rounded-t-md  w-full h-full " src={!item.accept_employee?.picture ? noneProfile : item.accept_employee?.picture} alt="" />
                </div>
                <label className="absolute opacity-80 p-1 mx-auto z-50 top-2 right-2 text-white group bg-red-500  font-semibold  rounded-full                                                                                                  w-8 h-8 flex items-center justify-center text-md  ">
                  {isRemovingApprover ? (
                    <Loader className="animate-spin" />
                  ) : (
                    <Minus
                      onClick={async () => {
                        if (employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved") {
                          return;
                        }
                        setIsRemovingApprover(true);
                        await new Promise((resolve) => setTimeout(resolve, 500)); // simulate API delay
                        setEmployeeInitRequest((prev: any) => ({
                          ...prev,
                          approvers: (prev.approvers || []).filter((approver: any) => approver.accept_employee?.id !== item.accept_employee?.id),
                        }));
                        setIsRemovingApprover(false);
                      }}
                      className={`w-8 h-8  ${
                        employeeInitRequest?.status === "Pending" || (employeeInitRequest?.status === "Approved" ? " cursor-not-allowed" : " cursor-pointer")
                      }`}
                    />
                  )}
                </label>
                <div className={`p-4 `}>
                  <h5 className="text-md font-semibold line-clamp-2 overflow-hidden h-[20px] ">{item?.accept_employee?.local_name}</h5>
                  <span className="text-sm line-clamp-1 overflow-hidden h-[20px]  ">{item?.accept_employee?.department}</span>

                  <p className=" font-semibold line-clamp-2 text-sm text-muted-foreground h-[20px]"> {item.accept_employee?.position}</p>

                  <p className="font-semibold line-clamp-2 text-sm  text-muted-foreground h-[20px]">
                    {(() => {
                      const date = new Date(item.accept_employee?.joined_date);
                      const day = date.getDate();
                      const weekday = date.toLocaleDateString("en-GB", {
                        weekday: "short",
                      });
                      const month = date.toLocaleDateString("en-GB", {
                        month: "short",
                      });

                      const year = date.getFullYear();
                      return `${month}, ${day}-${weekday}-${year}`;
                    })()}
                  </p>
                </div>
              </div>
            </>
          );
        })}
        {employeeInitRequest?.approvers?.length === 0 && (
          <div
            onClick={() => {
              if (employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved") {
                return;
              }
              setIsOpenDialogApporver(true);
              getShopEmployeeRequestCommittee("", employeeInitRequest);
            }}
            className={`${
              employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved" ? "" : "cursor-pointer"
            } h-[370px] flex items-center justify-center w-full max-w-sm rounded-lg  border border-gray-200 bg-gray-100 dark:bg-black`}
          >
            <label className="p-1 mx-auto z-50 top-2 right-2 text-white group bg-blue-500 font-semibold  rounded-full w-8 h-8 flex items-center justify-center text-md">
              <Plus className={`${employeeInitRequest?.status === "Pending" || employeeInitRequest?.status === "Approved" ? "" : "cursor-pointer"} text-sm  dark:text-white`} />
            </label>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddApproverRequest;
